export default __webpack_public_path__ + "static/media/1-3-people.31a463d8.png";